// CDCRD 2026 — Parámetros Sísmicos
// Código para el Diseño y Construcción de la República Dominicana 2026
// Basado en ASCE 7-16 adaptado para República Dominicana

// ─────────────────────────────────────────────────────────────────────────────
// Tabla F.2.9-1: Sistemas Estructurales CDCRD 2026
// R = Factor de reducción | Omega0 = Sobreresistencia | Cd = Amplificación deflexión
// Ct, x = Coeficientes período empírico: Ta = Ct · hn^x
// ─────────────────────────────────────────────────────────────────────────────
export const FACTORES_ESTRUCTURALES = {
  // A. PÓRTICOS RESISTENTES A MOMENTOS
  'Pórticos especiales de acero': {
    R: 8, Omega0: 3.0, Cd: 5.5, Ct: 0.0724, x: 0.8, grupo: 'Pórticos RM'
  },
  'Pórticos intermedios de acero': {
    R: 4.5, Omega0: 3.0, Cd: 4.0, Ct: 0.0724, x: 0.8, grupo: 'Pórticos RM'
  },
  'Pórticos ordinarios de acero': {
    R: 3.5, Omega0: 3.0, Cd: 3.0, Ct: 0.0724, x: 0.8, grupo: 'Pórticos RM'
  },
  'Pórticos especiales de hormigón armado': {
    R: 8, Omega0: 3.0, Cd: 5.5, Ct: 0.0466, x: 0.9, grupo: 'Pórticos RM'
  },
  'Pórticos intermedios de hormigón armado': {
    R: 5, Omega0: 3.0, Cd: 4.5, Ct: 0.0466, x: 0.9, grupo: 'Pórticos RM'
  },
  'Pórticos ordinarios de hormigón armado': {
    R: 3, Omega0: 3.0, Cd: 2.5, Ct: 0.0466, x: 0.9, grupo: 'Pórticos RM'
  },

  // B. SISTEMAS DE MUROS ESTRUCTURALES
  'Muros especiales de hormigón armado': {
    R: 6, Omega0: 2.5, Cd: 5.0, Ct: 0.0488, x: 0.75, grupo: 'Muros Estructurales'
  },
  'Muros ordinarios de hormigón armado': {
    R: 5, Omega0: 2.5, Cd: 4.5, Ct: 0.0488, x: 0.75, grupo: 'Muros Estructurales'
  },
  'Muros prefabricados especiales de HA': {
    R: 5, Omega0: 2.5, Cd: 5.0, Ct: 0.0488, x: 0.75, grupo: 'Muros Estructurales'
  },
  'Muros prefabricados ordinarios de HA': {
    R: 3, Omega0: 2.5, Cd: 3.0, Ct: 0.0488, x: 0.75, grupo: 'Muros Estructurales'
  },
  'Muros especiales de mampostería armada': {
    R: 5, Omega0: 2.5, Cd: 3.5, Ct: 0.0488, x: 0.75, grupo: 'Muros Estructurales'
  },
  'Muros intermedios de mampostería': {
    R: 3.5, Omega0: 2.5, Cd: 2.25, Ct: 0.0488, x: 0.75, grupo: 'Muros Estructurales'
  },
  'Muros ordinarios de mampostería': {
    R: 2, Omega0: 2.5, Cd: 1.75, Ct: 0.0488, x: 0.75, grupo: 'Muros Estructurales'
  },

  // C. SISTEMAS DUALES
  'Dual: Muros especiales HA + Pórticos especiales acero': {
    R: 8, Omega0: 2.5, Cd: 6.5, Ct: 0.0488, x: 0.75, grupo: 'Sistemas Duales'
  },
  'Dual: Muros especiales HA + Pórticos especiales HA': {
    R: 7, Omega0: 2.5, Cd: 5.5, Ct: 0.0488, x: 0.75, grupo: 'Sistemas Duales'
  },
  'Dual: Muros especiales HA + Pórticos intermedios HA': {
    R: 6.5, Omega0: 2.5, Cd: 5.0, Ct: 0.0488, x: 0.75, grupo: 'Sistemas Duales'
  },
  'Dual: Muros ordinarios HA + Pórticos especiales HA': {
    R: 6, Omega0: 2.5, Cd: 5.0, Ct: 0.0488, x: 0.75, grupo: 'Sistemas Duales'
  },
  'Dual: Muros mampostería especial + Pórticos especiales HA': {
    R: 5.5, Omega0: 2.5, Cd: 4.5, Ct: 0.0488, x: 0.75, grupo: 'Sistemas Duales'
  },

  // D. PÓRTICOS CON ARRIOSTRAMIENTO
  'Pórticos de acero con arriostramiento excéntrico': {
    R: 8, Omega0: 2.0, Cd: 4.0, Ct: 0.0731, x: 0.75, grupo: 'Pórticos Arriostrados'
  },
  'Pórticos de acero con arriostramiento concéntrico especial': {
    R: 6, Omega0: 2.0, Cd: 5.0, Ct: 0.0731, x: 0.75, grupo: 'Pórticos Arriostrados'
  },
  'Pórticos de acero con arriostramiento concéntrico ordinario': {
    R: 3.25, Omega0: 2.0, Cd: 3.25, Ct: 0.0731, x: 0.75, grupo: 'Pórticos Arriostrados'
  },

  // E. PÉNDULOS INVERTIDOS
  'Columnas péndulo invertido especiales de acero': {
    R: 2.5, Omega0: 2.0, Cd: 2.5, Ct: 0.0488, x: 0.75, grupo: 'Péndulos Invertidos'
  },
  'Columnas péndulo invertido especiales de HA': {
    R: 2.5, Omega0: 2.0, Cd: 2.5, Ct: 0.0488, x: 0.75, grupo: 'Péndulos Invertidos'
  },
};

// Mantenemos alias para compatibilidad con InputParameters.js
export const SISTEMAS_SISMORRESISTENTES = {};

// ─────────────────────────────────────────────────────────────────────────────
// Categorías de riesgo CDCRD 2026 y factor de importancia Ie
// ─────────────────────────────────────────────────────────────────────────────
export const CATEGORIAS_RIESGO = {
  'I':   { Ie: 1.00, descripcion: 'Bajo riesgo para vidas humanas (almacenes, instalaciones agrícolas)' },
  'II':  { Ie: 1.00, descripcion: 'Edificaciones de uso general (residencial, comercial, oficinas)' },
  'III': { Ie: 1.25, descripcion: 'Ocupación especial (escuelas >250, edificios >5000 personas)' },
  'IV':  { Ie: 1.50, descripcion: 'Instalaciones esenciales (hospitales, bomberos, telecomunicaciones, EOC)' },
};

// ─────────────────────────────────────────────────────────────────────────────
// Factor Cu (CDCRD 2026 / ASCE 7-16 Tabla 12.8-1) — límite superior período
// ─────────────────────────────────────────────────────────────────────────────
export function getCu(sd1) {
  if (sd1 >= 0.4)  return 1.4;
  if (sd1 >= 0.3)  return 1.4;
  if (sd1 >= 0.2)  return 1.5;
  if (sd1 >= 0.15) return 1.6;
  return 1.7;
}

// ─────────────────────────────────────────────────────────────────────────────
// Tabla Fa — CDCRD 2026 (Tabla F.2.9-2a)
// ─────────────────────────────────────────────────────────────────────────────
const FACTORES_FA = {
  'A': [0.8, 0.8, 0.8, 0.8, 0.8, 0.8],
  'B': [1.0, 1.0, 1.0, 1.0, 1.0, 1.0],
  'C': [1.2, 1.2, 1.1, 1.0, 1.0, 1.0],
  'D': [1.6, 1.4, 1.2, 1.1, 1.0, 1.0],
  'E': [2.5, 1.7, 1.2, 0.9, 0.9, 0.9],
};
const VALORES_SS = [0.25, 0.50, 0.75, 1.00, 1.25, 1.50];

// ─────────────────────────────────────────────────────────────────────────────
// Tabla Fv — CDCRD 2026 (Tabla F.2.9-2b)
// ─────────────────────────────────────────────────────────────────────────────
const FACTORES_FV = {
  'A': [0.8, 0.8, 0.8, 0.8, 0.8],
  'B': [1.0, 1.0, 1.0, 1.0, 1.0],
  'C': [1.7, 1.6, 1.5, 1.4, 1.3],
  'D': [2.4, 2.0, 1.8, 1.6, 1.5],
  'E': [3.5, 3.2, 2.8, 2.4, 2.4],
};
const VALORES_S1 = [0.10, 0.20, 0.30, 0.40, 0.50];

// ─────────────────────────────────────────────────────────────────────────────
// Clase principal: AnalisisSismico CDCRD 2026
// ─────────────────────────────────────────────────────────────────────────────
export class AnalisisSismico {
  constructor(params) {
    const {
      tipo_suelo,
      categoria_riesgo,
      ss,
      s1,
      campo_cercano = false,
      sistema_estructural,
      altura,
      irregularidades = {},
    } = params;

    this.tipo_suelo       = tipo_suelo;
    this.categoria_riesgo = categoria_riesgo;
    this.ss               = ss;
    this.s1               = s1;
    this.campo_cercano    = campo_cercano;
    this.sistema_estructural = sistema_estructural;
    this.altura           = altura;
    this.irregularidades  = irregularidades;

    this.factores = FACTORES_ESTRUCTURALES[sistema_estructural];
    if (!this.factores) {
      throw new Error(`Sistema estructural no válido: ${sistema_estructural}`);
    }

    const cat = CATEGORIAS_RIESGO[categoria_riesgo];
    if (!cat) {
      throw new Error(`Categoría de riesgo no válida: ${categoria_riesgo}`);
    }

    this.Ie     = cat.Ie;
    this.R      = this.factores.R;
    this.Omega0 = this.factores.Omega0;
    this.Cd     = this.factores.Cd;

    this.calcularParametrosBasicos();
  }

  // ── Interpolación lineal Fa ───────────────────────────────────────────────
  obtenerFa(ss) {
    const fila = FACTORES_FA[this.tipo_suelo];
    if (!fila) throw new Error(`Tipo de suelo no válido: ${this.tipo_suelo}`);

    if (ss <= VALORES_SS[0]) return fila[0];
    if (ss >= VALORES_SS[VALORES_SS.length - 1]) return fila[fila.length - 1];

    let i = 0;
    while (i < VALORES_SS.length - 1 && VALORES_SS[i + 1] <= ss) i++;
    return fila[i] + (ss - VALORES_SS[i]) * (fila[i + 1] - fila[i]) / (VALORES_SS[i + 1] - VALORES_SS[i]);
  }

  // ── Interpolación lineal Fv ───────────────────────────────────────────────
  obtenerFv(s1) {
    const fila = FACTORES_FV[this.tipo_suelo];
    if (!fila) throw new Error(`Tipo de suelo no válido: ${this.tipo_suelo}`);

    if (s1 <= VALORES_S1[0]) return fila[0];
    if (s1 >= VALORES_S1[VALORES_S1.length - 1]) return fila[fila.length - 1];

    let i = 0;
    while (i < VALORES_S1.length - 1 && VALORES_S1[i + 1] <= s1) i++;
    return fila[i] + (s1 - VALORES_S1[i]) * (fila[i + 1] - fila[i]) / (VALORES_S1[i + 1] - VALORES_S1[i]);
  }

  // ── Parámetros espectrales ────────────────────────────────────────────────
  calcularParametrosBasicos() {
    this.fa = this.obtenerFa(this.ss);
    this.fv = this.obtenerFv(this.s1);

    // Campo cercano: usa Fa·Ss y Fv·S1 sin reducción 2/3
    if (this.campo_cercano) {
      this.sds = this.fa * this.ss;
      this.sd1 = this.fv * this.s1;
    } else {
      this.sds = (2 / 3) * this.fa * this.ss;
      this.sd1 = (2 / 3) * this.fv * this.s1;
    }

    this.t0 = 0.2 * this.sd1 / this.sds;
    this.ts = this.sd1 / this.sds;

    this.calcularPeriodos();
    this.cds  = this.calcularCDS();
    this.rho  = this.calcularRho();
    this.calcularCs();
  }

  // ── Período empírico Ta y límite superior Cu·Ta ───────────────────────────
  calcularPeriodos() {
    const { Ct, x } = this.factores;
    this.ta      = Ct * Math.pow(this.altura, x);
    this.cu      = getCu(this.sd1);
    this.ta_max  = this.cu * this.ta;
    this.t_design = this.ta;
  }

  // ── Categoría de Diseño Sísmico (CDS) ────────────────────────────────────
  calcularCDS() {
    const cat       = this.categoria_riesgo;
    const { sds, sd1, s1 } = this;

    // E o F si S1 ≥ 0.75g
    if (s1 >= 0.75) return cat === 'IV' ? 'F' : 'E';

    // Por SDS (Tabla F.2.9-3a)
    let cds_sds;
    if (sds < 0.167)      cds_sds = 'A';
    else if (sds < 0.33)  cds_sds = cat === 'IV' ? 'C' : 'B';
    else if (sds < 0.50)  cds_sds = (cat === 'I' || cat === 'II') ? 'C' : 'D';
    else                  cds_sds = 'D';

    // Por SD1 (Tabla F.2.9-3b)
    let cds_sd1;
    if (sd1 < 0.067)      cds_sd1 = 'A';
    else if (sd1 < 0.133) cds_sd1 = cat === 'IV' ? 'C' : 'B';
    else if (sd1 < 0.20)  cds_sd1 = (cat === 'I' || cat === 'II') ? 'C' : 'D';
    else                  cds_sd1 = 'D';

    const order = ['A', 'B', 'C', 'D', 'E', 'F'];
    return order[Math.max(order.indexOf(cds_sds), order.indexOf(cds_sd1))];
  }

  // ── Factor de redundancia ρ ───────────────────────────────────────────────
  calcularRho() {
    const hayIrregularidad = Object.values(this.irregularidades).some(v => v === true);
    return hayIrregularidad ? 1.3 : 1.0;
  }

  // ── Forma del espectro de diseño ──────────────────────────────────────────
  // Sec. 2.9.4.5.1 (campo lejano): rama ascendente 0.4*SDS hasta T0, meseta SDS, descenso SD1/T
  // Sec. 2.9.4.5.2 (campo cercano): meseta SDS desde T=0 (sin rama ascendente), descenso SD1/T
  calcularSa(t) {
    if (this.campo_cercano) {
      // Espectro plano desde T=0: Sa = SDS para todo T <= Ts
      if (t <= this.ts) return this.sds;
      return this.sd1 / t;
    }
    // Espectro estandar de dos periodos
    if (!t || t === 0) return this.sds * 0.4;
    if (t <= this.t0)      return this.sds * (0.4 + 0.6 * t / this.t0);
    if (t <= this.ts)      return this.sds;
    return this.sd1 / t;
  }

  // ── Coeficiente sísmico Cs ────────────────────────────────────────────────
  calcularCs() {
    const { sds, s1, Ie, R } = this;
    const T = this.t_design;

    // Sa en el período de diseño (usa calcularSa para respetar forma campo cercano/lejano)
    const sa = this.calcularSa(T);

    // Cs base (Ec. F.2.9-1)
    let cs = sa * Ie / R;

    // Mínimo Cs (Ec. F.2.9-5 y F.2.9-6)
    this.cs_min = Math.max(0.044 * sds * Ie, 0.01);
    if (s1 >= 0.6) {
      this.cs_min = Math.max(this.cs_min, 0.5 * s1 * Ie / R);
    }

    // Aplicar ρ
    cs = cs * this.rho;

    this.sa_design = sa;
    this.cs = Math.max(cs, this.cs_min);
  }

  // ── Generar puntos del espectro ───────────────────────────────────────────
  generarEspectro(t_max = 4.0, num_puntos = 400) {
    const t = Array.from({ length: num_puntos }, (_, i) => (i * t_max) / (num_puntos - 1));

    // Espectro elastico de diseno (forma campo cercano o lejano segun seccion 2.9.4.5)
    const sa = t.map(ti => this.calcularSa(ti));

    // Espectro MCE (Fa*Ss / Fv*S1, sin reduccion 2/3, misma forma segun campo cercano)
    const sms = this.fa * this.ss;
    const sm1 = this.fv * this.s1;
    const t0m = sms > 0 ? 0.2 * sm1 / sms : 0;
    const tsm = sms > 0 ? sm1 / sms : 0;
    const saMCE = t.map(ti => {
      if (this.campo_cercano) {
        if (ti <= tsm) return sms;
        return sm1 / ti;
      }
      if (!ti || ti === 0) return sms * 0.4;
      if (ti <= t0m) return sms * (0.4 + 0.6 * ti / t0m);
      if (ti <= tsm) return sms;
      return sm1 / ti;
    });

    // Espectro de demanda de la estructura (reducido por R/Ie y rho)
    const saDiseno = sa.map(val => (val * this.Ie / this.R) * this.rho);

    return {
      t, sa, saMCE, saDiseno,
      t0: this.t0, ts: this.ts, ta: this.ta, ta_max: this.ta_max,
      campoCercano: this.campo_cercano,
    };
  }

  // ── Resultados completos ──────────────────────────────────────────────────
  obtenerResultados() {
    return {
      // Entrada
      tipoSuelo:         this.tipo_suelo,
      categoriaRiesgo:   this.categoria_riesgo,
      ss:                this.ss,
      s1:                this.s1,
      campoCercano:      this.campo_cercano,
      sistemaEstructural: this.sistema_estructural,
      altura:            this.altura,

      // Amplificación
      fa: this.fa,
      fv: this.fv,

      // Espectral
      sds: this.sds,
      sd1: this.sd1,
      t0:  this.t0,
      ts:  this.ts,

      // Sistema
      R:      this.R,
      Ie:     this.Ie,
      Omega0: this.Omega0,
      Cd:     this.Cd,

      // Períodos
      ta:       this.ta,
      cu:       this.cu,
      ta_max:   this.ta_max,
      t_design: this.t_design,

      // CDS y redundancia
      cds: this.cds,
      rho: this.rho,

      // Coeficiente sísmico
      cs:     this.cs,
      cs_min: this.cs_min,
      sa_design: this.sa_design,

      // Espectro
      espectro: this.generarEspectro(),
    };
  }
}
